const SvgNetworking2 = (props) => (
  <>
    <circle r={4} fill={props.p30} />
    <path
      d="M96 16c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80Zm0 96c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16Z"
      fill={props.p20}
      fillRule="evenodd"
      stroke={props.p30}
      strokeMiterlimit={10}
    />
    <path fill="none" stroke={props.p30} strokeMiterlimit={10} d="M84.5 84.5.8.71" />
  </>
);

export default SvgNetworking2;
